"use client";



import Select, {components} from "react-select";
import {useRouter} from "next/navigation";
import {useEffect, useId, useState} from "react";
import {usePhrase} from "../../../i18n";

const Input = (props) => {
    if (props.isHidden) {
        return <div style={{ border: `1px dotted red` }}>222<components.Input {...props} aria-activedescendant={'test'} /></div>;
    }
    return (
        <div className={`hidden`}>
            <div content={'Custom Input'}>
                <components.Input {...props}  aria-activedescendant={'test'}  />
            </div>
        </div>
    );
};



const LanguageSelector = ({ config, storeCode, _t }) => {

    const t = usePhrase(_t);

    const router = useRouter();
    const [selectedStore, setSelectedStore] = useState({label: config.store.code.slice(0,2).toUpperCase(), value: config.store.code});

    const storeViews = config.stores.filter(s => s.website_id===config.store.website_id).map(s => ({label: s.code.slice(0,2).toUpperCase(), value: s.code}));


    useEffect(() => {

        if(selectedStore?.value !== storeCode) {
            const redirectTo = config.stores.find(s => s.code === selectedStore?.value)?.secure_base_url || null;
            if(redirectTo) {
                router.push(redirectTo);
            }
        }
    }, [selectedStore]);

    const handleChange = (v) => {
        console.log(v);
        setSelectedStore(v);
    }

    return (
        <div className="language-selector">
            <Select
                aria-label={t('Language Selector')}
                instanceId={useId()}
                className="language-selector__select"
                classNamePrefix="language-selector__select"
                options={storeViews}
                value={selectedStore}
                components={{Input}}
                onChange={handleChange}
                isSearchable={true}
                /* isSearchable true for fix aria-active-descendant issue */
                theme={theme => ({
                    ...theme,
                    borderRadius: 0,
                    colors: {
                        ...theme.colors,
                        primary25: '#fce8ba',
                        primary: '#e7bb43'
                    },
                })}
                styles={{
                    control: (provided, state) => ({
                        ...provided,
                        backgroundColor: 'transparent',
                        border: 'none',
                        boxShadow: 'none',
                        color: 'white',
                        fontSize: '0.9rem',
                        textTransform: 'uppercase',
                        cursor: 'pointer',
                        '&:hover': {
                            borderColor: 'transparent',
                            boxShadow: 'none'
                        },
                        minHeight: '20px',
                    }),
                    indicatorSeparator: (provided, state) => ({
                        ...provided,
                        display: 'none'
                    }),
                    dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: '#333',
                        paddingLeft: '0',
                        paddingRight: '0',
                        paddingTop: '0',
                        paddingBottom: '0',
                        display: storeViews.length > 1 ? 'block' : 'none'
                    }),

                }}
            />
        </div>
    );
};

export default LanguageSelector;